import { on } from 'delegated-events'
import debounce from 'lodash/debounce'
import scrollTo from '../common/scrollTo'
import Pristine from 'pristinejs'

const SELECTORS = Selectors({
  donationForm: 'donation-form',
  stripeCardElement: 'card-element',
  thirdpartyPayment: 'payment-thirdparty',
  paypalElement: 'paypal-payment-container'
})

const $form = document.querySelector(SELECTORS.asClass('donationForm'))
const $cardElement = document.getElementById(SELECTORS.stripeCardElement)
const $thirdPartyElement = document.getElementById(SELECTORS.thirdpartyPayment)
const $repeatDonation = document.getElementById('DonationForm_DonationForm_RepeatDonation_Holder')
const $repeatDuration = document.getElementById('DonationForm_DonationForm_RepeatDuration_Holder')
const $otherAmountField = document.getElementById('DonationForm_DonationForm_OtherAmount')
const $submitButton = document.querySelector('[type=submit][name=action_finish]')
const $sessionField = document.querySelector('[type=hidden][name=MultiFormSessionID]')

const state = {
  stripe: null,
  stripeCard: null,
  paypal: null,
  paymentRequest: null,
  isRepeating: null
}

const pristineConfig = {
  classTo: 'field',
  errorClass: 'has-error',
  successClass: 'has-success',
  errorTextParent: 'field',
  errorTextTag: 'div',
  errorTextClass: 'text-help'
}

const fn = {
  init: () => {
    if ($cardElement) {
      state.stripe = window.Stripe($form.dataset.stripePubKey)
      state.isRepeating = $form.querySelector('[type=hidden][name=IsRepeating]')
      fn.setupStripeCard()
    }

    if ($thirdPartyElement) {
      state.paypal = window.paypal

      // Load in any session data we need to complete a thirdparty transaction
      $.ajax({
        type: 'post',
        dataType: 'json',
        url: `${$form.dataset.controllerUrl}fetchsessiondata`,
        data: {
          sessionId: $sessionField.value
        },
        success: (resp) => {
          if (state.isRepeating) {
            const $paypal = document.getElementById(SELECTORS.paypalElement)

            if ($paypal) {
              $paypal.style.display = 'none'
            }
          } else {
            $form.classList.add('has-thirdparty')
            fn.setupPaypal(resp)
          }

          fn.setupApplePay(resp)
        }
      })
    }

    if ($form) {
      fn.bindEvents()
      fn.setupValidation()
    }
  },

  bindEvents: () => {
    // Setup any events for AmountStep
    if ($form.classList.contains('amount-step')) {
      on('change', '[name=PresetAmount]:not([value=Other])', () => {
        $otherAmountField.value = null
      })

      on('change', '[name=PresetAmount][value=Other]', (e) => {
        if (e.target.checked) {
          $otherAmountField.focus()
        }
      })

      $otherAmountField.addEventListener('focus', () => {
        document.querySelector('[name=PresetAmount][value=Other]').checked = true
      })

      $repeatDonation.querySelector('[type=checkbox]').addEventListener('change', (e) => {
        if (e.target.checked) {
          $repeatDuration.classList.add('is-active')
        } else {
          $repeatDuration.classList.remove('is-active')
          $repeatDuration.querySelector('select').value = null
        }
      })

      if ($repeatDonation.querySelector('[type=checkbox]:checked')) {
          $repeatDuration.classList.add('is-active')
      }

      on('click', '.donation-check-toggle', () => {
        $('.donation-check-content').slideToggle('fast')
      })
    }

    // Setup any events for DetailsStep
    if ($form.classList.contains('details-step')) {
      $form.querySelector('[type=checkbox]').addEventListener('change', (e) => {
        if (e.target.checked) {
          $('.notify-email').slideToggle('fast')
          $('input[name="HonorEmail"]').attr('required', true)
          fn.setupValidation()
        } else {
          $('.notify-email').slideToggle('fast')
          $('input[name="HonorEmail"]').attr('required', false)
          fn.setupValidation()
        }
      })
    }

    // Setup any events for PaymentStep
    if ($form.classList.contains('payment-step')) {
      $form.addEventListener('submit', fn.handleSubmit)

      // Setup form's submit button(s) to handle cases where we want to skip validation
      $form.querySelectorAll('[type=submit]').forEach($el => {
        $el.addEventListener('click', function () {
          this.form.skipValidation = this.getAttribute('formnovalidate') === 'formnovalidate'
        })
      })
    }
  },

  setupValidation: () => {
    const pristine = new Pristine($form, pristineConfig)

    if ($repeatDuration) {
      pristine.addValidator($repeatDuration.querySelector('select'), function (value) {
        if ($repeatDonation.querySelector('[type=checkbox]:checked')) {
          return value !== ''
        }

        return true
      }, 'Please select an option', 10, false)
    }

    if ($otherAmountField) {
      pristine.addValidator($otherAmountField, function (value) {
        const $presetAmount = document.querySelector('[name=PresetAmount]:checked')
        const isSelectingOtherAmount = $presetAmount && $presetAmount.value === 'Other'

        if (!isSelectingOtherAmount) {
          return true
        }

        return isSelectingOtherAmount && value !== ''
      }, 'Please enter an amount', 10, false)
    }

    // Revalidate easydropdown fields on change
    on('change',
      `${SELECTORS.asClass('donationForm')} select`,
      e => pristine.validate(e.target)
    )

    $form.addEventListener('submit', (e) => {
      if (e.target.skipValidation) {
        return true
      }

      const valid = pristine.validate()

      if (!valid) {
        e.preventDefault()
        const $firstError = $form.querySelector('.field.has-error')

        if ($firstError) {
          scrollTo($firstError, 150, () => $firstError.querySelector('input') && $firstError.querySelector('input').focus())
        }

        return false
      }
    })
  },

  setupStripeCard: () => {
    const style = {
      base: {
        fontSize: '16px',
        fontFamily: 'Open Sans, sans-serif',
        color: '#2c2c2c',
        fontSmoothing: 'antialiased',
        textTransform: 'uppercase',
        '::placeholder': {
          color: '#b4b4b4'
        }
      },
      invalid: {
        color: '#b9112a'
      }
    }

    const card = state.stripe.elements().create('card', { style })
    card.mount(SELECTORS.asId('stripeCardElement'))
    state.stripeCard = card

    card.addEventListener('change', ({error}) => {
      const displayError = document.getElementById('card-errors')
      if (error) {
        displayError.textContent = error.message
      } else {
        displayError.textContent = ''
      }
    })

    window.addEventListener('resize', debounce(fn.updateStripeCard, 250))
    fn.updateStripeCard()
  },

  updateStripeCard: () => {
    let fontSize = '16px'

    if (window.matchMedia('(min-width: 1200px)').matches) {
      fontSize = '18px'
    }

    const style = {
      base: {
        fontSize
      }
    }

    state.stripeCard.update({ style })
  },

  setupPaypal: (sessionData) => {
    state.paypal.Buttons({
      style: {
        layout: 'horizontal',
        color: 'white',
        height: 55,
        tagline: false
      },
      createOrder: function (data, actions) {
        return actions.order.create({
          purchase_units: [{
            amount: {
              value: sessionData.amount
            }
          }]
        })
      },
      onApprove: function(data, actions) {
        return actions.order.capture().then(function (details) {
          const hiddenInput = document.createElement('input')
          hiddenInput.setAttribute('type', 'hidden')
          hiddenInput.setAttribute('name', 'paypalPayload')
          hiddenInput.setAttribute('value', JSON.stringify(details))
          $form.appendChild(hiddenInput)

          $form.forceSubmit = true
          $submitButton.disabled = false
          $submitButton.click()
          $submitButton.disabled = true
        });
      }
    }).render(SELECTORS.asId('paypalElement'))
  },

  setupApplePay: (sessionData) => {
    const paymentRequest = state.stripe.paymentRequest({
      country: 'US',
      currency: 'usd',
      total: {
        label: 'The Center Donation',
        amount: sessionData.amount_as_cents
      },
      requestPayerName: true,
      requestPayerEmail: true
    })

    const paymentRequestButton = state.stripe.elements().create('paymentRequestButton', {
      paymentRequest: paymentRequest,
      style: {
        paymentRequestButton: {
          height: '55px'
        }
      }
    })

    // Check the availability of the Payment Request API first
    paymentRequest.canMakePayment().then(function(result) {
      if (result && result.applePay) {
        paymentRequestButton.mount('#payment-request-button');
        state.paymentRequest = paymentRequest

        $form.classList.add('has-thirdparty')
      } else {
        document.getElementById('payment-request-button').style.display = 'none';
      }
    })

    paymentRequest.on('token', (e) => {
      const hiddenInput = document.createElement('input')
      hiddenInput.setAttribute('type', 'hidden')
      hiddenInput.setAttribute('name', 'stripeApplePayToken')
      hiddenInput.setAttribute('value', e.token.id)
      $form.appendChild(hiddenInput)

      $form.forceSubmit = true
      $submitButton.disabled = false
      $submitButton.click()
      $submitButton.disabled = true
    })
  },

  handleSubmit: (e) => {
    if (e.target.skipValidation || e.target.forceSubmit) {
      return true
    }

    // Handle PayPal - if PayPal was used there should be a hidden input
    // with payload data, if so we should skip validation for Stripe and submit
    if ($form.classList.contains('payment-step')) {
      if (document.querySelector('[name=paypalPayload]')) {
        return true
      }
    }

    e.preventDefault()

    // Handle Stripe
    $submitButton.disabled = true

    state.stripe.createToken(state.stripeCard).then((result) => {
      if (result.error) {
        const errorElement = document.getElementById('card-errors')
        errorElement.textContent = result.error.message
      } else {
        fn.stripeTokenHandler(result.token)
      }
    })

    return false
  },

  stripeTokenHandler: (token) => {
    const hiddenInput = document.createElement('input')
    hiddenInput.setAttribute('type', 'hidden')
    hiddenInput.setAttribute('name', 'stripeToken')
    hiddenInput.setAttribute('value', token.id)
    $form.appendChild(hiddenInput)

    $form.forceSubmit = true
    $submitButton.disabled = false
    $submitButton.click()
    $submitButton.disabled = true
  }
}

export default {
  can: () => document.body.classList.contains('pagetype-donationpage'),
  run: fn.init
}
